import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./AboutMe.css";

export default function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTSANTS = {
    description: `A highly skilled Full Stack Web Developer with over 2 years of experience, specializing in the MERN stack (MongoDB, Express.js, React.js, Node.js) and proficient in Redux for state management. I have a proven track record of building efficient, scalable, and high-performance web applications. My expertise extends to implementing CI/CD pipelines to streamline deployment processes and ensure continuous integration and delivery, enhancing both development speed and product reliability.

Passionate about coding and driven by problem-solving, I possess strong analytical skills, a quick learning ability, and a flexible mindset that allows me to adapt to evolving technologies and project requirements. I am seeking to contribute to an organization that values innovation and offers opportunities for professional growth, skill enhancement, and continuous development.`,
    highlights: {
      bullets: [
        "Contributed to the development and enhancement of micro-UI components, ensuring seamless integration within the core product. ",
        "Led the design and implementation of performant and scalable UI solutions, collaborating with cross-functional teams to meet project requirements.",
        "Worked closely with product management to discuss feature requirements and translated them into fully developed frontend solutions with high code quality.",
        "Ensured the end-to-end development of frontend features, from design to deployment, while maintaining consistent code quality and meeting deadlines.",
        "Collaborated with backend teams for efficient API integration, optimizing communication between frontend and backend services.",
        "Focused on code optimization and scalability, working alongside senior developers to ensure high-performing and scalable frontend applications.",
        "Demonstrated expertise in backend development using Node.js, Express, and MongoDB, creating robust APIs and ensuring seamless data integration with the frontend for optimized performance and scalability.",
      ],
      heading: "Work Experience",
    },
  };
  const renderHighlight = () => {
    return SCREEN_CONSTSANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description">
              {SCREEN_CONSTSANTS.description}
            </span>
            <div className="about-me-highlights">
              <div className="highlight-heading">
                <span className="work-exp">
                  {SCREEN_CONSTSANTS.highlights.heading}
                </span>
                <p>Software Engineer at Right Prompt Technology</p>
                <p className="work-date">oct 2023 - jul 2024 | Bangalore </p>
              </div>
              {renderHighlight()}
            </div>
            <div className="about-me-options">
              <button
                className="btn primary-btn"
                onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
              >
                {" "}
                Hire Me{" "}
              </button>
              <a
                href="https://drive.google.com/file/d/11RsmGM5rY3suLIMJyBo6hTTF_skOdp4R/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                download=""
              >
                <button className="btn highlighted-btn">Get Resume</button>
                <div></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
